import { isNotDefined, getMACalculator } from "../utils";
import { RAVI as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { shortPeriod, longPeriod, sourcePath, maType } = options;

    // Get MA calculator using centralized utility
    const maCalculator = getMACalculator(maType);

    // Calculate Short MA
    const shortMA = maCalculator().options({
      windowSize: shortPeriod,
      sourcePath,
    });
    const shortValues = shortMA(data);

    // Calculate Long MA
    const longMA = maCalculator().options({
      windowSize: longPeriod,
      sourcePath,
    });
    const longValues = longMA(data);

    // Calculate RAVI percentage difference
    const raviValues = data.map((d, i) => {
      const shortValue = shortValues[i];
      const longValue = longValues[i];

      if (
        isNotDefined(shortValue) ||
        isNotDefined(longValue) ||
        longValue === 0
      ) {
        return undefined;
      }

      // RAVI Formula: 100 × ((Short MA / Long MA) - 1)
      const ravi = 100 * (shortValue / longValue - 1);

      return ravi;
    });

    // Add direction flag for coloring bars (increasing vs decreasing)
    const result = raviValues.map((value, i) => {
      if (isNotDefined(value)) return undefined;

      const prevValue = i > 0 ? raviValues[i - 1] : undefined;
      let direction = "up";

      if (!isNotDefined(prevValue)) {
        direction = value >= prevValue ? "up" : "down";
      }

      return {
        value,
        direction,
      };
    });

    return result;
  }

  calculator.undefinedLength = function () {
    return options.longPeriod - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
